import React, { useState, useEffect } from 'react';
import { ListingCard } from '../../components';
import { getLatestListings } from './utils';
import { FormattedMessage } from '../../util/reactIntl';
import {
  getUserSubscriptionLevel,
  SUBSCRIPTION_LEVEL_2,
  isStartup
} from '../../util/types';

import classNames from 'classnames';

import css from './LatestListingsSection.module.css';

const GenericMessage = props => {
  const { show, textId } = props;
  const classes = classNames(css.genericMessage, {
    [css.genericMessageVisible]: show,
  });
  return (
    <div className={classes}>
      <div className={css.genericMessageContent}>
        <p className={css.genericMessageText}>
          <FormattedMessage id={textId} />
        </p>
      </div>
    </div>
  );
};

function LatestListingsSection(props) {
  const { currentUser, setProviderType, isAuthenticated } = props;
  const [latestListings, setLatestListings] = useState([]);
  const [showCompany, setShowCompany] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedValue = localStorage.getItem('semotoShowCompany');
      if (storedValue !== null) {
        setShowCompany(JSON.parse(storedValue));
      }
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedValue = localStorage.getItem('semotoShowCompany');

      if ((!!currentUser?.id?.uuid && !isStartup(currentUser) && storedValue === 'false') || !isAuthenticated) {
        setShowCompany(true)
        localStorage.setItem('semotoShowCompany', JSON.stringify(true));
      }
    }
  }, [currentUser]);

  // const isProvider = currentUser?.attributes?.profile?.publicData?.userType === 'service-provider';
  const userSubscriptionLevel = getUserSubscriptionLevel(currentUser);
  const subscriptionLevelToLow = userSubscriptionLevel < SUBSCRIPTION_LEVEL_2;

  let params = {
    pub_listingType: 'provider',
    pub_providerType: showCompany ? 'establishedCompany' : 'startup',
    page: 1,
    perPage: 6,
    sort: showCompany ? 'createdAt' : 'pub_votesAvg',
    states: 'published'
  }

  if (!showCompany) {
    params.pub_hideStartupOnHomepage = false;
    params.sort = 'pub_totalVotes';
  }

  if (!currentUser && showCompany) {
    params.pub_showOnHomepage = true;
  }

  if (subscriptionLevelToLow && showCompany) {
    params.pub_subscriptionLevel = "0,10"
    params.sort = 'createdAt,pub_subscriptionLevel'
  }

  const handleToggleView = () => {
    const newValue = !showCompany;
    setShowCompany(newValue);
    if (typeof window !== 'undefined') {
      localStorage.setItem('semotoShowCompany', JSON.stringify(newValue));
    }
    setProviderType(newValue ? 'establishedCompany' : 'startup');
  };

  useEffect(() => {
    if (isLoading) return;

    getLatestListings(params, true)
      .then(resp => {
        if (!currentUser && showCompany && !resp?.length) {
          delete params.pub_showOnHomepage;
          return getLatestListings(params, true);
        }
        return resp;
      })
      .then(resp => setLatestListings(resp))
      .catch(e => console.log(e));
  }, [currentUser, showCompany, isLoading]);


  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  const [isGenericMessageOpen, setIsGenericMessageOpen] = useState(false);

  const onChangeGenericMessageOpen = (status) => {
    setIsGenericMessageOpen(status)
  }

  return (
    <div className={css.sectionContent}>

      <GenericMessage
        show={isGenericMessageOpen}
        textId={"SearchPage.upgradeSubscriptionPlan"}
      />

      {/* Feature #73379 */}
      {/* 5. Temporarily hide toggle on the homepage for everyone. Only keep it for the Startup users */}
      {isStartup(currentUser) && (
        <div className={css.toggleHolder}>
          <span>Companies View</span>
          {!isLoading && (
            <div
              className={classNames(css.toggle, { [css.toggleActive]: !showCompany })}
              onClick={handleToggleView}
            />
          )}
          <span>Startup View</span>
        </div>
      )}


      <h2 className={css.sectionTitle}>{showCompany ? 'Latest providers' : 'Most voted startups'}</h2>

      {!!latestListings?.length && (
        <div className={css.itemWrapper}>
          {latestListings.map((l, index) => {
            return (
              <ListingCard
                className={css.item}
                key={l.id.uuid}
                listing={l}
                renderSizes={cardRenderSizes}
                setActiveListing={() => { }}
                titleOnTop={true}
                currentUser={currentUser}
                onChangeGenericMessageOpen={onChangeGenericMessageOpen}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LatestListingsSection;
